import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { whatsappUrl } from "../components/SiteShell";

const dmconContact = `${whatsappUrl}?text=${encodeURIComponent("Olá, Vagner! Conheci a DMCon pela página de parceiros do Executive Jiu-Jitsu e gostaria de saber mais sobre consórcios.")}`;
const partnerContact = `${whatsappUrl}?text=${encodeURIComponent("Olá, Vagner! Tenho interesse em apresentar minha empresa e conhecer as parcerias do Executive Jiu-Jitsu.")}`;

export function PartnersPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Parcerias Estratégicas | Executive Jiu-Jitsu";
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const connections = (t("partners.connectionAreas.items", { returnObjects: true }) as Array<{
    num: string;
    title: string;
    desc: string;
  }>) || [];

  return (
    <main>
      <section className="partners-hero">
        <div>
          <p className="eyebrow">{t("partners.hero.eyebrow")}</p>
          <h1>
            {t("partners.hero.title").split(".")[0]}.
            <br />
            <em>{t("partners.hero.title").split(".")[1] || ""}</em>
          </h1>
          <p>{t("partners.hero.subtitle")}</p>
          <a className="button" href="#parceiros">
            {t("partners.hero.cta")}
          </a>
        </div>
        <div className="partners-hero-mark">
          <span>{t("partners.hero.markTag")}</span>
          <strong>{t("partners.hero.markTitle")}</strong>
          <p>{t("partners.hero.markSubtitle")}</p>
        </div>
      </section>

      <section className="partners-intro">
        <div>
          <p className="eyebrow">{t("partners.intro.eyebrow")}</p>
          <h2>
            {t("partners.intro.title").split(".")[0]}.
            <br />
            <em>{t("partners.intro.title").split(".")[1] || ""}</em>
          </h2>
        </div>
        <p>{t("partners.intro.desc")}</p>
      </section>

      <section className="partners-showcase" id="parceiros">
        <div className="section-intro">
          <p className="eyebrow">{t("partners.showcase.eyebrow")}</p>
          <h2>
            {t("partners.showcase.title").split(".")[0]}.
            <br />
            <em>{t("partners.showcase.title").split(".")[1] || ""}</em>
          </h2>
        </div>
        <article className="featured-partner">
          <div className="featured-partner-brand">
            <span>{t("partners.showcase.partnerTag")}</span>
            <strong>
              DM<span>CON</span>
            </strong>
            <p>CONSÓRCIOS</p>
          </div>
          <div className="featured-partner-content">
            <span className="partner-category">{t("partners.showcase.category")}</span>
            <h3>
              {t("partners.showcase.cardTitle").split(".")[0]}.
              <br />
              <em>{t("partners.showcase.cardTitle").split(".")[1] || ""}</em>
            </h3>
            <p>{t("partners.showcase.cardDesc")}</p>
            <div className="partner-tags">
              <span>{t("partners.showcase.tag1")}</span>
              <span>{t("partners.showcase.tag2")}</span>
              <span>{t("partners.showcase.tag3")}</span>
            </div>
            <a className="button" href={dmconContact} target="_blank" rel="noopener noreferrer">
              {t("partners.showcase.cta")}
            </a>
          </div>
        </article>
        <p className="partner-disclosure">{t("partners.showcase.disclosure")}</p>
      </section>

      <section className="connection-areas">
        <div className="section-intro light-intro">
          <p className="eyebrow">{t("partners.connectionAreas.eyebrow")}</p>
          <h2>
            {t("partners.connectionAreas.title").split(".")[0]}.
            <br />
            <em>{t("partners.connectionAreas.title").split(".")[1] || ""}</em>
          </h2>
        </div>
        <div className="connections-grid">
          {connections.map((c) => (
            <article key={c.num}>
              <span>{c.num}</span>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="partner-invitation">
        <p className="eyebrow">{t("partners.invitation.eyebrow")}</p>
        <h2>
          {t("partners.invitation.title").split(".")[0]}
          <br />
          <em>{t("partners.invitation.title")}</em>
        </h2>
        <p>{t("partners.invitation.desc")}</p>
        <a className="button dark-button" href={partnerContact} target="_blank" rel="noopener noreferrer">
          {t("partners.invitation.cta")}
        </a>
      </section>
    </main>
  );
}
